import Plyr from 'plyr';

(() => {
    const $showreelVideo = document.querySelector('.showreel-video');
    const $workcarouselPlayShowreelBtn = document.querySelector('.workcarousel-play-showreel-btn');

    const initVideo = () => {
        if (!$showreelVideo || !$workcarouselPlayShowreelBtn) return;
    
        const player = new Plyr($showreelVideo, {
            controls: `
            <button type="button" class="showreel-video__close-btn">
                <div class="screen-reader-text">Close</div>
            </button>
            <div class="plyr__controls">
                <button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play">
                    <svg class="icon--pressed" aria-hidden="true" focusable="false">
                        <use xlink:href="#plyr-pause"></use>
                    </svg>
                    <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
                        <use xlink:href="#plyr-play"></use>
                    </svg>
                    <span class="label--pressed plyr__sr-only">Pause</span>
                    <span class="label--not-pressed plyr__sr-only">Play</span>
                </button>
                <div class="plyr__controls__item plyr__progress__container">
                    <div class="plyr__progress">
                        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
                        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
                        <span role="tooltip" class="plyr__tooltip">00:00</span>
                    </div>
                </div>
                <div class="plyr__controls__item plyr__time plyr__time--current" aria-label="Current time">00:00</div>
                <div class="plyr__controls__item plyr__volume">
                        <button type="button" class="plyr__control" data-plyr="mute">
                            <svg class="icon--pressed" aria-hidden="true" focusable="false">
                                <use xlink:href="#plyr-muted"></use>
                            </svg>
                            <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
                                <use xlink:href="#plyr-volume"></use>
                            </svg>
                            <span class="label--pressed plyr__sr-only">Unmute</span>
                            <span class="label--not-pressed plyr__sr-only">Mute</span>
                        </button>
                    <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
                </div>
                <button class="plyr__controls__item plyr__control" type="button" data-plyr="fullscreen">
                    <svg class="icon--pressed" aria-hidden="true" focusable="false">
                        <use xlink:href="#plyr-exit-fullscreen"></use>
                    </svg>
                    <svg class="icon--not-pressed" aria-hidden="true" focusable="false">
                        <use xlink:href="#plyr-enter-fullscreen"></use>
                    </svg>
                    <span class="label--pressed plyr__sr-only">Exit fullscreen</span>
                    <span class="label--not-pressed plyr__sr-only">Enter fullscreen</span>
                </button>
            </div>`
        });

        $workcarouselPlayShowreelBtn.addEventListener('click', () => {
            player.fullscreen.enter();
            player.play();
        });

        player.on('exitfullscreen', () => {
            player.stop();
        });

        player.on('ready', () => {
            const $showreelVideoCloseBtn = document.querySelector('.showreel-video__close-btn');

            if ($showreelVideoCloseBtn) {
                $showreelVideoCloseBtn.addEventListener('click', () => {
                    player.fullscreen.exit();
                })
            }
        });
    }
    
    initVideo();
})();
